import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon, BookOpenIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const pillar = {
  icon: BookOpenIcon,
  tag: 'Incluido 📚',
  title: 'Colección Rentable (5 Tomos)',
  value: '69€',
  today: 'Hoy: Incluido',
  lead: 'Todo lo que necesitas para facturar tus primeros 500€/mes.',
  items: ['El Radar Montessori: Cómo dominar el mercado infantil que crece +18% anual en España. Torres de aprendizaje, triángulos Pikler, estanterías infantiles.', 'Decoración "Slim" & Lifestyle: Soportes de laptop minimalistas, estantes flotantes hexagonales, organizadores de escritorio premium. Se venden en 24h.', 'El Lujo en la Cocina: Tablas gourmet que transforman tus sobras de roble o nogal en 40-80€. End-grain, diseño nórdico, acabado profesional.', 'El Arte del Acabado Premium: Cómo hacer que cualquier madera parezca de revista. Aceites orgánicos, técnicas de cera, color y textura que hipnotiza.', 'Ventas de Guerrilla: Domina Wallapop e Instagram España. Scripts listos. Fotos que venden. Cómo no regatear. Cómo cerrar.']
};
export function WhatYouGet() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-269" data-mp="2zzi10qm9wttz">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-270" data-mp="34vypjlxdxa7l">
        <SectionTag icon="🎁" data-id="element-271" data-mp="39wdzs4mde1lc">Lo que recibes hoy (Acceso Inmediato)</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-272" data-mp="3dxg2ivfhwvs2">
          Todo lo que necesitas, en un solo lugar.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-273" data-mp="3iuq1b1oryjsk">
          Todo lo que necesitas para facturar tus primeros 500€/mes.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 sm:px-6" data-id="element-274" data-mp="3slawef58p66q">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="flex flex-col rounded-2xl border border-brown/20 bg-white p-6 shadow-card sm:p-7" data-id="element-275" data-mp="1g1fdcz84299">
          <div className="flex items-start justify-between gap-3" data-id="element-276" data-mp="1xj63ojr1e2f2">
            <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-brown/10" data-id="element-277" data-mp="1xl0ozz67zwjo">
              <pillar.icon size={22} className="text-brown" data-id="element-278" data-mp="2bcoz5wwwsay0" />
            </div>
            <span className="rounded-full bg-ink/5 px-3 py-1 text-xs font-semibold text-muted" data-id="element-279" data-mp="26ib1toyortqp">
              {pillar.tag}
            </span>
          </div>
          <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-ink sm:text-xl" data-id="element-280" data-mp="2ga6zx00rvjux">
            {pillar.title}
          </h3>
          <div className="mt-2 flex items-baseline gap-2 text-sm" data-id="element-281" data-mp="2u8wwmejojhir">
            <span className="text-muted line-through" data-id="element-282" data-mp="2q7bloyqphdb7">Valor: {pillar.value}</span>
            <span className="font-semibold text-success" data-id="element-283" data-mp="zv5ppmsqjbr0">{pillar.today}</span>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-284" data-mp="vttzpg5y8oia">{pillar.lead}</p>
          <ul className="mt-4 space-y-2.5" data-id="element-285" data-mp="vvwuselyl7tv">
            {pillar.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-ink/90" data-id="element-286" data-mp="lqov17o8vhfm">
                <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-287" data-mp="ptl8kjyxgncp" />
                <span data-id="element-288" data-mp="bztz1bl753gz">{item}</span>
              </li>)}
          </ul>
        </m.div>
      </div>
    </section>;
}